import type { ContentFieldKey } from './channel-constants';

const MAP: Partial<Record<ContentFieldKey, string>> = {
  Name: 'headline',
  Description: 'channel_description',
  SeoMetaDescription: 'seo_meta',
};

/** Backend field_type for a channel content field, or null if not AI-generatable. */
export function fieldTypeForChannelField(field: ContentFieldKey): string | null {
  return MAP[field] ?? null;
}
